module.exports = __webpack_public_path__ + "img/club-card-dialog-negative.5f581a2e.svg";